import { Route } from 'react-router-dom';
import { Flow } from 'signup-constants/Flow';
import AcademyRoute from './AcademyRoute';
import FacebookCrmRoute from './FacebookCrmRoute';
import IntegrationsRoute from './IntegrationsRoute';
import TrialRoute from './TrialRoute';
import { ViewContainer } from './ViewContainer';
import MicroappRoute from './MicroappRoute';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomRoutes = new Map([[Flow.Integrations, IntegrationsRoute], [Flow.Microapp, MicroappRoute], [Flow.Trial, TrialRoute], [Flow.FbCrm, FacebookCrmRoute], [Flow.Academy, AcademyRoute]]);
export const useFlowRoutes = () => {
  const flowRoutes = Object.entries(Flow).filter(([, value]) => !CustomRoutes.has(value)).map(([key, path]) => /*#__PURE__*/_jsx(Route, {
    component: ViewContainer,
    path: `/${path}`
  }, key));

  // Render all custom routes
  CustomRoutes.forEach((CustomFlowRoute, flowKey) => {
    flowRoutes.push( /*#__PURE__*/_jsx(CustomFlowRoute, {
      component: ViewContainer,
      path: `/${flowKey}`
    }, flowKey));
  });
  return flowRoutes;
};